import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default {
  data: function data() {},
  methods: {
    saveRemark: function saveRemark(text, info) {
      info.remark = text;
    },
    //otherKey 当列表需要两个 用户信息时参数
    getUserListByIds: function getUserListByIds() {
      var _this = this;
      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var key = arguments.length > 1 ? arguments[1] : undefined;
      var otherKey = arguments.length > 2 ? arguments[2] : undefined;
      var keyName = arguments.length > 3 ? arguments[3] : undefined;
      var otherKeyName = arguments.length > 4 ? arguments[4] : undefined;
      var userIds = arr.map(function (item) {
        return item[key];
      });
      var otherIds = [];
      if (otherKey) {
        otherIds = arr.map(function (item) {
          return item[otherKey];
        });
      }
      userIds = _toConsumableArray(new Set(otherIds.concat(userIds)));
      if (!userIds.length) return;
      this.$api.getUserListByIds({
        userIds: userIds
      }).then(function (res) {
        arr.forEach(function (item) {
          _this.$set(item, keyName || "userInfo", res.data[item[key]]);
          if (otherKey) {
            _this.$set(item, otherKeyName || "otherUserInfo", res.data[item[otherKey]]);
          }
        });
      });
    },
    //单独处理user/deviceId 设备ID 页面多个关联用户展示问题
    getUserListByIdsMore: function getUserListByIdsMore() {
      var _this2 = this;
      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var key = arguments.length > 1 ? arguments[1] : undefined;
      var NewArr = JSON.parse(JSON.stringify(arr));
      var userIds = [];
      NewArr.forEach(function (item) {
        var _item$key;
        if ((_item$key = item[key]) !== null && _item$key !== void 0 && _item$key.length) {
          item[key].forEach(function (i) {
            userIds.push(i.id);
          });
        }
      });
      userIds = _toConsumableArray(new Set(userIds));
      if (!userIds.length) return;
      return new Promise(function (resolve) {
        _this2.$api.getUserListByIds({
          userIds: userIds
        }).then(function (res) {
          NewArr.forEach(function (item) {
            item.userInfoList = [];
            item[key].forEach(function (i) {
              if (res.data[i.id]) {
                item.userInfoList.push(_objectSpread(_objectSpread({}, res.data[i.id]), {}, {
                  created_at: i.created_at,
                  processed: i.processed
                }));
              }
            });
          });
          resolve(NewArr);
        });
      });
    }
  }
};